module.exports = __webpack_public_path__ + "img/home_jd_icon.2ec5347.png";